module.exports = __webpack_public_path__ + "img/MSC-alt.69300639.svg";